const oldUrlMethod = "partsfinder.";
const urlTrails = ["swan-", "-dev", "-test"];

const portalInformations = {
  askoll: {
    csoft:            '850026',
    grant_type:       'password',
  },
  beta: {
    csoft:            '850036',
    grant_type:       'client_credentials',
    client_id:        'Z3KJvTuAjocEpTTxIpxPlrWKnEVVO2yii9eHQLtK',
    client_secret:    'be51ETGNrRhARxnrE2nyz89kiJph4pJPsegrGYLjkHeT2pC1tpftw6tLKw6k5Ud1lJYOWtCVBYzbtc5ZVp58LxYoAq3DBxX5BLRZlDbUwuGkN2rBTgKzA6PpbmvUkqRx',
  },
  zontes: {
    csoft:            '850038',
    grant_type:       'client_credentials',
    client_id:        'Wnh3ObuRUh6KzWBGtETl9QGdyb0fJvrcWyQQvcGk',
    client_secret:    'wWDH2qTMNJ03XKbKdUmyOzh8rvlWyRFppVTGc2F5NEfLXMEEoEoVPKLYteJtSsvIIc8AudH8dW30FmUOIrC36RqLGEFcifAnEUMheIx9zsS9I4fQvbk1DRSceCE7mhgN',
  },
  qooder: {
    csoft:            '850200',
    grant_type:       'client_credentials',
    client_id:        'nM4EcfoeLSTdaxYUsijTZQsV6u1FBOI9j9dtwvRC',
    client_secret:    'MCjjCKbdOwufA2oRA8luWb3em3OSNfbFiYEYxOkSztFfQRAuaCPcsfhvC3QvLRByWiSkREqIHeC1tYPBLSJInrobp3wmuXT3HuJAfRvZHgVzp1arJEkqw4B3Cc2r2baP',
  },
  mvagusta: {
    csoft:            '850100',
    grant_type:       'authorization-code',
  },
  // softway: {
  //   csoft:            '900000',
  //   grant_type:       'client_credentials',
  //   client_id:        'qpNKVdYrwgCEgFDc5cHIrSeREXxOufVBQA3IoABO',
  //   client_secret:    '9W4w1GWbT0hPFKXCOQBnivC5CkpUeV1aoou9Z5iLmgwmePOqieDLWk9yL23AOXNfclb6pA9KSaMazfy8HOBiDg6zULFqIGk8DY6iKuZHLf6OlzRWASicfLgJk1PLrINk',
  // },
  softway: {
    csoft:            '900000',
    grant_type:       'client_credentials',
    client_id:        '',
    client_secret:    '',
  },
  partsprocatalog: {
    csoft:            '900000',
    grant_type:       'client_credentials',
    client_id:        '',
    client_secret:    '',
  },
  psc: {
    csoft:            '900000',
    grant_type:       'client_credentials',
    client_id:        '',
    client_secret:    '',
  },
};

const devOauth = {
  LOGIN_BACKEND: "http://" + window.location.host + "/",
  BACKEND: "http://" + window.location.host + "/partsfinder/backend/",
  BACKEND_ANSWER: "http://" + window.location.host + "/partsfinder/backend/",
  FRONTEND: window.location.protocol + "//" + window.location.host + "/partsfinder/",
  STATIC: window.location.protocol + "//" + window.location.host + "/partsfinder/static/",
  MENU_ICONS_PATH: window.location.protocol + "//" + window.location.host + "/partsfinder/static/images/icone/",
  BASEPATH: "/partsfinder/",
  APP_NAME: "Parts Finder",
  RECAPTCHA_CLIENT_ID: '0x4AAAAAAA1zvwK1ExHUa6aU',
  RECAPTCHA_VERIFY: true,
  PORTAL_NAME: "softway",
  CSOFT: 900000,
}

const dev = {
  //LOGIN_BACKEND: Manca
  BACKEND: "http://localhost:8008/",
  BACKEND_ANSWER: "http://localhost:8008/",
  FRONTEND: window.location.protocol + "//" + window.location.host + "/",
  STATIC: window.location.protocol + "//" + window.location.host + "/static/",
  MENU_ICONS_PATH: window.location.protocol + "//" + window.location.host + "/static/images/icone/",
  BASEPATH: "/",
  APP_NAME: "Parts Finder",
  RECAPTCHA_CLIENT_ID: '0x4AAAAAAA1zvwK1ExHUa6aU',
  RECAPTCHA_VERIFY: true,
  PORTAL_NAME: "beta",
  CSOFT: 850036,
}

const prod = {
  LOGIN_BACKEND: window.location.protocol + "//" + window.location.host + "/",
  BACKEND: window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/backend/",
  BACKEND_ANSWER: window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/backend/",
  FRONTEND: window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/",
  STATIC: window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/static/",
  MENU_ICONS_PATH: window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/static/images/icone/",
  BASEPATH: "/" + window.location.pathname.split('/')[1] + "/",
  APP_NAME: "Parts Finder",
  RECAPTCHA_CLIENT_ID: '0x4AAAAAAA1zvwK1ExHUa6aU',
  RECAPTCHA_VERIFY: true,
  PORTAL_NAME: "softway",
  CSOFT: 900000
}

var config = {}, tmp = false, portalName = window.location.host.split(".")[0];
for(let i in urlTrails){
  portalName = portalName.replace(new RegExp(urlTrails[i], ""), "");
}

if(process.env.NODE_ENV === "production"){
  config = prod;
  config.PRODUZIONE = true;
}else{
  try{
    config = eval(process.env.REACT_APP_PERSONAL_ENV);
  }catch(e){
    config = dev;
  }
  if(typeof(config) !== "object" || config.FRONTEND === undefined || config.FRONTEND === null || config.FRONTEND === '')
    config = dev;
  if(portalName === undefined || portalName === null)
    portalName = config.PORTAL_NAME;
  config.PRODUZIONE = false;
}

config.OLD_METHOD = window.location.host.startsWith(oldUrlMethod);
if(config.OLD_METHOD){
  config.LOGIN_BACKEND = undefined;
  config.PORTAL_NAME = window.location.pathname.split('/')[1];
  portalName = config.PORTAL_NAME;

  config.BACKEND = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/backend/";
  config.BACKEND_ANSWER = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/backend/";
  config.FRONTEND = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/";
  config.STATIC = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/static/";
  config.MENU_ICONS_PATH = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/static/images/icone/";
  config.BASEPATH = "/" + window.location.pathname.split('/')[1] + "/";
}

// if(config.RECAPTCHA_VERIFY !== undefined && config.RECAPTCHA_VERIFY !== null)
//   config.RECAPTCHA_VERIFY = config.PRODUZIONE;
if(config.MISSING_TRANSLATIONS_ALERT !== undefined && config.MISSING_TRANSLATIONS_ALERT !== null)
  config.MISSING_TRANSLATIONS_ALERT = !config.PRODUZIONE;

if(!config.PRODUZIONE)
  config.APP_NAME = "!!TEST MODE!! " + config.APP_NAME;
tmp = get_portal_information(portalName, "csoft");
config.CSOFT = (tmp !== false ? tmp : 900000);
tmp = get_portal_information(portalName, "grant_type");
config.BACKEND_LOGIN_GRANT_TYPE = (tmp !== false ? tmp : 'authorization-code');
tmp = get_portal_information(portalName, "client_id");
config.BACKEND_LOGIN_CLIENT_ID = (tmp !== false ? tmp : 'RPHijZkJNM9tLKuww7jm1wHZcDnWL5KchobHKIfX');
tmp = get_portal_information(portalName, "client_secret");
config.BACKEND_LOGIN_CLIENT_SECRET = (tmp !== false ? tmp : 'WKUO0tb0SatqvVkR6MuZsYcVTDAPyHGkuexoyFaeOUDBjs29uNJV8yjCrEhtw5RKAWCjxP8S1VrTJlxqseppNjrfmHrPMdv7dfFLeXNkzBC3m7msrJFtvdj9ZmrOBTLU');

function get_portal_information(portalName, infoName) {
  if(portalInformations[portalName] !== undefined && portalInformations[portalName][infoName] !== undefined && portalInformations[portalName][infoName] !== null){
    console.log(infoName, portalInformations[portalName], portalInformations[portalName][infoName])
    return portalInformations[portalName][infoName]
  }

  return false;
}

export default {
  ...config,
  languageName: {it: "Italiano", en: "English", de: "Deutsch", es: "Español", fr: "Français"},
  labels: {},
}
